import React, { FC, useContext } from 'react';
import { TopPerformingBrokers } from './components/TopPerformingBrokers';
import SummaryCard from './components/SummaryCard';
import ActiveLeadsCard from './components/ActiveLeadsCard';
import DealByStatusCard from './components/DealByStatusCard';
import EnterpriseNavigation from '../../components/EnterpriseNavigation';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { BUSINESS_ROUTE } from 'data/global';
import { Navigate } from 'react-router-dom';

import './Analytics.styles.scss';
import './Analytics.styles.responsive.scss';

const Analytics: FC = () => {
  const { isOfficeManager } = useContext(CurrentUserContext);

  if (isOfficeManager) return <Navigate to={BUSINESS_ROUTE} replace />;

  return (
    <div className="enterprise-analytics">
      <EnterpriseNavigation />

      <div className="enterprise-analytics__cards">
        <SummaryCard />
        <TopPerformingBrokers />
        <DealByStatusCard />
        <ActiveLeadsCard />
      </div>
    </div>
  );
};

export default Analytics;
